
import { Injectable } from '@angular/core';
import { SiriusServiceBase, SiriusDataService } from '@ibtech/sirius-angular-service';

@Injectable()
export class InnerMenuService extends SiriusServiceBase {
    constructor() {
        super();
    }

    getInnerMenuSidebarItemsData(dataService: SiriusDataService) {
        var promise = dataService.get("GetInnerMenuSidebarItems");
        return promise;
    }
}
